// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__1Cpsn","content":"Modal_content__1KVLj","emoji":"Modal_emoji__3PXY3","text":"Modal_text__1hVbx"};